import React from "react";

function About() {
  return (
    <div>
      <h2>Om speidergruppa</h2>
      <p>
        Holmenkollen-Riis speidergruppe er en aktiv gruppe som holder til ved Skådalen, vest i Oslo.
        Vi har speidere i alle aldre, fra ulvunger og tropp (barne- og ungdomsskolealder) til rovere.
      </p>
      <p>
        Både ulvungene og troppen har møter hver uke, med ulike aktiviteter både innendørs og utendørs.
        Utenom møtene er vi mye på tur, det være seg snøhuletur, sommerleir, telttur i marka, kretskonk, eller tur til en av hyttene våre.
      </p>
      <p>
        Gruppa er organisert i flokk, tropp og rovere.
        Flokken huser ulvungene, som er speiderne opp til fjerdeklasse.
        I troppen er speiderne til de er ferdige med ungdomsskolen.
        Troppen er delt inn i patruljer (grupper på 5-8 speidere), der hver patrulje har en egen patruljefører og assistent.
        Etterhvert som speiderne blir enda eldre blir de en del av roverne. Roverne i HRiis er gjerne med på å organisere og lede møter, turer og leirer.
      </p>
    </div>
  );
}

export default About;